export const LANDING = {
  TITLE: 'Become a PullRequest Reviewer',
  DESCRIPTION:
    'Our reviewer network features specialized developers that have a passion for code review. Apply to join our network of world-class engineers, and help development teams ship their best code.',
  NAME_LABEL: 'Name',
  NAME_PLACEHOLDER: 'First Last',
  EMAIL_LABEL: 'Email',
  EMAIL_PLACEHOLDER: 'you@example.com',
  PASSWORD_LABEL: 'Password',
  PASSWORD_PLACEHOLDER: '(at least {NUM_CHARACTERS} characters)',
  WHAT_IS_PULLREQUEST: "What's PullRequest?",
  PULL_REQUEST_DESCRIPTION_1:
    'PullRequest provides on demand code review as a service from exceptional engineers to teams of any size.',
  PULL_REQUEST_DESCRIPTION_2:
    "As a reviewer in our network, you'll use our impressive code review platform to help teams fix bugs, catch security threats, improve readability, and reduce technical debt.",
  DAVE_IVELL_QUOTE:
    'The process is flawless. Code review opportunities are available in real time, 24 hours a day whenever I want to jump in and review code.',
  DAVE_IVELL_FOUNDER: 'Dave Ivell (Reviewer since May 2018)',
  MARK_MULLAN_QUOTE:
    "I find informal mentorship through code review is highly enjoyable work. Overall, reviewing with PullRequest has been one of the best consulting experiences I've had.",
  MARK_MULLAN_FOUNDER: 'Mark Mullan (Reviewer since June 2020)',
  ALAIN_CHAUTARD_QUOTE:
    'PullRequest is a great way to get some additional income whenever you want it. I also like that the platform is exposing me to so many different coding styles and architectures.',
  ALAIN_CHAUTARD_FOUNDER: 'Alain Chautard (Reviewer since November 2019)',
  WHY_REVIEW: 'Why review with PullRequest?',
  MONEY_TITLE: 'Make extra money',
  MONEY_DESCRIPTION:
    'PullRequest reviewers are payed hourly and earn a significant side income.',
  FLEXIBLE_TITLE: 'Choose your own hours',
  FLEXIBLE_DESCRIPTION: 'No commitment. Review whenever you have spare time.',
  QUALITY_TITLE: 'Unparalleled experience',
  QUALITY_DESCRIPTION:
    'Make a difference in code quality by helping teams write great code.',
  COMMUNITY_TITLE: 'Join an all-star community',
  COMMUNITY_DESCRIPTION:
    'Work alongside other industry experts with engineering experience ranging from startups to big tech.',
  EXISTING_MODAL_TITLE: 'Existing Account',
  EXISTING_MODAL_TEXT:
    "It looks like there's already an account associated with this email address.",
  EXISTING_MODAL_BUTTON_LABEL: 'Go to Sign In',
  NON_US_MODAL_TITLE: 'Are you based in the US?',
  NON_US_MODAL_PROMPT:
    "It looks like you're currently outside of the US. Are you based in the United States?",
  NON_US_MODAL_BUTTON_LABEL: 'Continue',
  NON_US_MODAL_YES: "Yes, I'm based in the US.",
  NON_US_MODAL_NO: "No, I'm based outside of the US.",
  NAME_ERROR: 'Please provide your first and last name.',
  EMAIL_ERROR: 'Please provide a valid email address.',
  PASSWORD_ERROR: 'Your password must be at least {NUM_CHARACTERS} characters.',
  PWND_ERROR:
    'This password may have previously been breached on another service, please pick another.',
  LEARN_MORE: 'Learn More',
  TERMS: 'Terms',
  PRIVACY: 'Privacy',
  SECURITY: 'Security',
  COPYRIGHT: 'Copyright © 2021 PullRequest, Inc. All rights reserved.',
};

export const EMAIL_VERIFICATION = {
  TITLE: 'Verify your email',
  SUBTITLE: "We've sent you a verification email.",
  SUBJECT: '[Reviewer Application] Unable to verify email',
  EXPLANATORY_TEXT:
    "We're excited that you're applying! Please click the verification link in the following inbox to continue:",
  RESENDING: 'Resending the verification email.',
  RESENT: 'We just re-sent your verification email to {EMAIL}.',
  VERIFICATION_FAILED: 'Verification failed',
};

export const APPLICATION_SUBMITTED = {
  TITLE: 'Thanks for applying, {USERNAME}!',
  TITLE_BACKUP: 'Thanks for applying!',
  EXPLANATORY_TEXT:
    "Thanks for applying to join the PullRequest network. We'll review your application and reach out to you via email with the next steps.",
  EMAIL_SUBJECT: '[Reviewer Application] When will my application be reviewed?',
};

export const REVIEWER_ONBOARDING = {
  LANDING,
  EMAIL_VERIFICATION,
  APPLICATION_SUBMITTED,
};
